import * as React from 'react';
import Select from '../../elements/Select';

import {Card} from '../../elements';

import {PlanContext, usePlanContext} from '../../context/PlanContext';
import { Controller, useFormContext } from 'react-hook-form';
import { PlanFormValues } from './PlanFormInfo.type';

export function PlanFormProgramsComponent() : JSX.Element {

  const {
    programsOptions,
  } = usePlanContext();
  
  const form = useFormContext<PlanFormValues>();

  return(
      <div className="row">
        <div className="col s12">
          <Card title={'Quais programas de treino esse plano dá acesso'}>
          <div className="row">
            <div className="col s12">
              <label htmlFor="">Programas de treino</label>
            </div>
          </div>
          <div className="row">
            <div className="col s12">
              <Controller
                name="planPrograms"
                control={form.control}
                render={({ field }) => (
                  <Select
                    options={programsOptions}
                    placeholder={'Digite/Selecione um programa de treino'}
                    onChange={field.onChange}
                    selectType="select2"
                    value={field.value}
                  />
                )}
                />
              </div>
          </div>
          </Card>
        </div>
      </div>
  )
}